import { ResponsivePie } from "@nivo/pie";
import { Box } from "@mui/material";

const SkillsSummaryChart = ({ skills }) => {
  if (!skills) return null;

  const data = [
    {
      id: "Twarde",
      label: "Twarde",
      value: Number(skills.hardSkills || 0),
    },
    {
      id: "Miękkie",
      label: "Miękkie",
      value: Number(skills.softSkills || 0),
    },
  ];

  const colorMapping = {
    Twarde: "#294e6b",
    Miękkie: "#6cc6d9",
  };

  return (
    <Box sx={{ height: 400 }}>
      <ResponsivePie
        data={data}
        innerRadius={0.7}
        padAngle={2}
        cornerRadius={3}
        activeOuterRadiusOffset={3}
        margin={{ top: 20, right: 20, bottom: 20, left: 20 }}
        enableArcLinkLabels={false}
        arcLabelsSkipAngle={20}
        arcLabelsTextColor="#ffffff"
        colors={(datum) => colorMapping[datum.id]}
        borderWidth={2}
        borderColor={{ from: "color", modifiers: [["darker", 0.3]] }}
      />
    </Box>

  );
};

export default SkillsSummaryChart;
